/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { BooleanServiceResult } from '../models/BooleanServiceResult';
import type { LoginRequest } from '../models/LoginRequest';
import type { LoginResponseServiceResult } from '../models/LoginResponseServiceResult';
import type { PasswordUpdateRequest } from '../models/PasswordUpdateRequest';
import type { StringServiceResult } from '../models/StringServiceResult';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class AuthenticationApiClient {

    /**
     * Login method
     * Login with user details to authenticate. If the details are correct the token can then be used to authenticate and call other end points.
     * @param requestBody
     * @returns LoginResponseServiceResult Returns LoginResponse model
     * @throws ApiError
     */
    public static postApiV1Login(
        requestBody?: LoginRequest,
    ): CancelablePromise<LoginResponseServiceResult> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/Login',
            body: requestBody,
            mediaType: 'application/json-patch+json',
            errors: {
                400: `Bad Request`,
                401: `Invalid Credentials`,
            },
        });
    }

    /**
     * Password reset method
     * Reset password via email link.
     * @param emailId
     * @returns StringServiceResult Returns PasswordResetResponse model
     * @throws ApiError
     */
    public static postApiV1LoginResetPassword(
        emailId?: string,
    ): CancelablePromise<StringServiceResult> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/Login/ResetPassword',
            query: {
                'EmailId': emailId,
            },
            errors: {
                401: `Un-authorized`,
            },
        });
    }

    /**
     * Password update method
     * Update new password via email link.
     * @param resetUid
     * @param requestBody
     * @returns BooleanServiceResult Returns UpdatePasswordResponse model
     * @throws ApiError
     */
    public static postApiV1LoginUpdatePassword(
        resetUid?: string,
        requestBody?: PasswordUpdateRequest,
    ): CancelablePromise<BooleanServiceResult> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/Login/UpdatePassword',
            query: {
                'ResetUid': resetUid,
            },
            body: requestBody,
            mediaType: 'application/json-patch+json',
        });
    }

}
